export const inheritasAddress = "0x5E322D41A18EECFa0a3dF9E612f44535908f6F32";
//export const inheritasAddress = "0x32Fd013B73Fd25558eC5A30D04111c522e84B9ff";
//export const inheritasAddress = "0xc7810AAD088EbfE1e29C9edf48D6a18FD0057B5c";

